import type { ListSegmentsParams } from '../generated/social-media/metapicSocialMediaAPIDocumentation.schemas'
import type { SegmentsFilter } from '../types/segments.types'

export const SEGMENTS_PAGE_LIMIT = 20

/**
 * `advertiser_id` is read by the endpoint's auth guard from the raw querystring to scope the
 * caller to a single advertiser; it is not part of the generated `ListSegmentsParams` DTO.
 */
export type SegmentsListParams = ListSegmentsParams & { advertiser_id?: number }

export type SegmentFilterContext = {
  currentUserId?: string
  advertiserId?: number
}

export const handleSegmentFilter = (
  filter: SegmentsFilter,
  context: SegmentFilterContext = {},
): SegmentsListParams => {
  const params: SegmentsListParams = { limit: SEGMENTS_PAGE_LIMIT }

  if (filter.page !== undefined) {
    params.page = filter.page
  }

  if (filter.query) {
    params.name = filter.query
  }

  if (filter.type) {
    params.type = filter.type
  }

  if (filter.advertiserGroup) {
    params.advertiser_group_id = filter.advertiserGroup.id
  }

  const advertiserId = context.advertiserId ?? filter.advertiser?.id
  if (advertiserId !== undefined) {
    params.advertiser_id = advertiserId
  }

  if (filter.createdByMe && context.currentUserId) {
    params.created_by_user_id = context.currentUserId
  }

  if (filter.sortBy) {
    params.sort_by = filter.sortBy
  }

  return params
}
